/*========================================================================
* $Id: editor.js 72847 2013-05-23 15:52:33Z jakob.praher $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "i18n/i18n",
  "backbone",
  "underscore",
  ],
  function(i18n, Backbone, _) {


    function buttonClassName(hidden) {
      hidden = hidden ? "hidden " : "";
      return hidden + 'pull-right btn btn-white mb-has-components-visible';
    }
    function icon(icon) {
      //onclick="return editor.exportReload()"
      //data-toggle="modal"
      return '<i class="' + icon + 'mb-icon-code-padding-right"></i>';
    }
    
    var ActionView = Backbone.View.extend({
      tagName: "div",
      className: 'pull-right btn btn-white mb-has-components-visible',
      events: {
        "click": "onClick"
      },
      
      initialize: function(options) {
        this.model = options.model;
        this.listenTo(this.model, "change", this.render);
      },

      onClick: function(e) {
        this.trigger("click", this.model, e, this);
      },
        

      render: function() {
        this.el.innerHTML = "";
        var label = this.model.get("label");
        var icon = this.model.get("icon");

        if (label) {
          label = i18n(label);
        }

        if (icon) {
          var iconEl = document.createElement("i");
          iconEl.className = icon + " mb-icon-code-padding-right";
          this.el.appendChild(iconEl);
        }

        if (label) {
          this.el.appendChild(document.createTextNode(label));
        }
        return this;
      },

    });


    var ActionsView = Backbone.View.extend({
      tag: "div",
      className: "pull-right button-wrapper",
      
      
      initialize: function(options) {
        this.views = [];
        this.collection = options.collection;
        this.listenTo(this.collection, "remove add change", this.render);
      },

      triggerClick: function() {
        var args = ["click"].concat(Array.from(arguments));
        this.trigger.apply(this, args);
      },

      render: function() {
        _.each(this.actionViews, function(view) {
          view.remove();
        });
        this.views = [];
        this.el.innerHTML = "";

        var that = this;
        _.each(this.collection.models, function(model) {
          if (model.get("hidden")) {
            return;
          }
          var view = new ActionView({model:model});
          view.render();
          that.views.push(view);
          that.listenTo(view, "click", that.triggerClick);
          that.el.appendChild(view.el);
        });
        return this;
      }
      
      
    });
    
    return ActionsView;

});
